import styled from 'styled-components/macro';

export const Container = styled.div`
  background: #f8f9f9;
  padding: 0.2rem 0 3rem 0;
`;
